@if (needsUpgrade$ | async) {
  @switch (theme()) {
    @case ('basic') {
      <button type="button" class="upgrade-button" [attr.data-id]="dataId()" (click)="onClick()" color="accent" mat-button>
        <ng-container *ngTemplateOutlet="buttonText" />
      </button>
    }
    @case ('stroked') {
      <button type="button" class="upgrade-button" [attr.data-id]="dataId()" (click)="onClick()" color="upgrade" mat-stroked-button>
        <ng-container *ngTemplateOutlet="buttonText" />
      </button>
    }
    @case ('inline') {
      <button type="button" class="text-purple-50" [attr.data-id]="dataId()" (click)="onClick()">
        <ng-container *ngTemplateOutlet="buttonText" />
      </button>
    }
    @default {
      <button type="button" class="upgrade-button" [attr.data-id]="dataId()" (click)="onClick()" mat-flat-button color="upgrade">
        <rma-icon glyph="lock" matButtonIcon />
        <ng-container *ngTemplateOutlet="buttonText" />
      </button>
    }
  }
} @else {
  <ng-content />
}

<ng-template #link />

<ng-template #buttonText>
  @if (customUpgradePrimer()) {
    <span>{{ 'button.label.upgrade' | transloco }}</span>
  } @else {
     @if (trialPeriodDays$ | async; as trialPeriodDays) {
      <span>
        {{ overrideText() ?? 'button.label.trial' | transloco: { trialPeriodDays: trialPeriodDays } }}
      </span>
    } @else {
      <span>{{ overrideText() ?? 'button.label.upgrade' | transloco }}</span>
    }
  }
</ng-template>
